import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popMineCateShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/mine/category", {});
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "icon": "",
        'status': "1",
        "sort": "0",
        "icon_type": "0"
      };
      this.popMineCateShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popMineCateShow = true;
    },
    async onRemove(item) {
      this.isLoading = true;
      let rs = await this.$http.post("/mine/category/remove", {
        id: item.id
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onItems(item) {
      this.$router.push("/minetask?id=" + item.id);
    }
  },
  mounted() {
    this.getData();
  }
};